<template>
    <v-combobox
        v-model="decision"
        :items="options"
        :label="label"
        prepend-icon="mdi-chevron-down-circle"
        clearable
        chips>
    </v-combobox>
</template>

<script>
    import { eventBus } from '../../../../../main';


    export default {
        name : 'requeststatuscombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/RequestStatusCombo.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$on('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/RequestStatusCombo.vue >>> mounted');
            this.setTrueOrFalse();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/RequestStatusCombo.vue >>> beforeDestroy');
            this.decision = null; // reset

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                decision: null,
                options: [
                    'REQUESTED',
                    'MAINREQUEST',
                    'SECONDARYREQUEST',
                    'REPLACEMENTREQUEST',
                    'APPROVED',
                    'REFUSED',
                ],
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setTrueOrFalse();

            }, // eo value()

            decision(value) {

                this.$emit('input', value);

            }, // eo checkbox()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods : {

            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setTrueOrFalse()
            *
            * Desc:
            * Note:
            *
            */
            setTrueOrFalse: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/RequestStatusCombo.vue >>> setTrueOrFalse');
                me.decision = this.value;

            }, // eo function setTrueOrFalse()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
